export default __webpack_public_path__ + "static/media/pink.1c662d50.gif";